<template>
  <div>
<h2 class="goth">Infinitiv vs perfektparticip</h2>
<div class="grammatikparagrafbredd leftorient">

<p>
Infinitiv och perfektparticip är två helt olika former av verbet som används på helt olika sätt.
Principerna liknar dem på svenska, men av oklar anledning blandas de ofta ihop av många
svenska tyskelever när de talar eller skriver tyska.
</p>

<br>
<h4>Infinitiv</h4>


<p>
Infinitiv är ett verbs grundform (oböjt) och används ofta tillsammans med ett modalt hjälpverb och föregås ibland av
<i>"zu" (att)</i>.
</p>

<div class="ruta">
<p><i>Det är kul att <b>spela</b> piano<br>
    Es macht Spaß Klavier zu <b>spielen</b>.</i> </p>


<p><i>Jag kan <b>spela</b> piano.<br>Ich kann Klavier <b>spielen</b>.</i>

<p><i>Jag kan också <b>sjunga</b> bra.<br>Ich kann auch gut <b>singen</b>.</i></p>

</div>

<p>Infitiv slutar alltid på <b><i>-en</i></b>, och hamnar sist i en huvudsats om ett modalt hjälpverb förekommer.</p>

<br>
<h4>Perfektparticip</h4>


<p>Perfektparticip motsvarar svenskans supinum när det används i tidsformen perfekt.
    För att skapa tidformen behöver man också ett hjälpverb. På svenska används här
    uteslutande hjälpverbet <i>har</i> medan tyskan använder någon form av <i>har</i> eller <i>är</i>.</p>

<div class="ruta">
    <p><i>Jag har <b>spelat</b> piano.<br>Ich habe Klavier <b>gespielt</b>.</i>

    <p><i>Jag har också <b>sjungit</b> bra.<br>Ich habe auch gut <b>gesungen</b>.</i></p>
</div>

<p>Perfektparticipen börjar ofta på (men inte alltid) <b><i>ge-</i></b> och slutar ofta på <b><i>-t</i></b>,
    handlar det om starka verb, slutar de emellerid på <b><i>-en</i></b>. Perfektpartipen hamnar sist i huvudsats.</p>
<br>
<p>Kanske är det det faktum att både infinitiv och perfektparticip, till skillnad från svenskan,
    på tyska alltid hamnar sist i huvudsats, samt att båda ibland kan sluta på <b><i>-en</i></b> som gett upphov till förvirringen.
</p>

<br>

</div>
</div>


</template>

<script>
export default {
  name: 'Grammatik',
  props: {
    msg: String
},
metaInfo() {
    return {
        meta: [
            {
                vmid: "description",
                name: "description",
                content: "infinitiv perfektparticip perfekt particip modala hjälpverb"
            }
        ]
    }
},

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

th {
    font-weight: bold;
}
</style>
